<template>
  <v-card class="text-center" elevation="0">
    <v-card-title class="justify-center">
      {{ $t("password.forgotPassword") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column align-center">
      <v-icon class="mb-3" size="80">mdi-email</v-icon>
      <h3 class="mb-3">{{ $t("password.aLinkToResetYourPasswordWillBeSent") }}</h3>
      <i18n class="mb-6" path="password.didNotReceive">
        <template #link>
          <a href="javascript:void()" @click="$router.back()">
            {{ $t("password.didNotReceiveLink") }}
          </a>
        </template>
      </i18n>
      <v-btn color="primary" to="/">
        {{ $t("password.backToSignIn") }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ResetPasswordRequestSent"
}
</script>